import React from 'react'
import ModalBody from "../modalbody"
import Loginbutton from './loginbutton';

const LoginModal = () => {
    return (
        <ModalBody heading={''}>
            <div className="p-25">
                <div className="flex-center">
                    <h2 className="f-600 text-center">Log in to Continue</h2>
                </div>
                <div className="m-t-20 p-b-10">
                    <Loginbutton />
                </div>
            </div>
        </ModalBody>
    )
}

export default LoginModal
